import axios from 'axios';

export default class FirebaseService
{
    public static async getFirebaseConfig()
    {
        return (await axios.get('auth/firebase')).data;
    }

    public static async setFirebaseToken(token: string)
    {
        return await axios.post('auth/firebase/token', { token });
    }
}
